module.exports = __webpack_public_path__ + "img/bullet-list.21fbeb5e.svg";